import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './../App.css';

export default function Footer(){
    const { t } = useTranslation(['footer']);

    useEffect(() => {
        return () => {
        };
    }, [])

    return(
        <>
            <div className='footer'>
                <div className='footer__con'>
                    <div className='footer__logo'>SOO UNIVERSE</div>
                    <div className='footer__txt-con'>
                        <div className='footer__txt01'> 
                            {t('footer:company_info')}
                        <br/>
                            {t('footer:business_number')}
                        <br/>
                            {t('footer:contact_number')}
                        <br/>
                        </div>
                        <div className='footer__txt02'>
                            <span></span>{t('footer:copyright')}
                        </div>
                    </div>
                    
                    <div className='footer__law-con'>
                        <a href={process.env.PUBLIC_URL + '/license'}>{t('footer:open_source_license')}</a>
                    </div>
                </div>
            </div>
        </>
    )
}